import React from 'react';
import './AppLinkSection.css';

export default function AppLinkSection() {
  const featureList = [
    "Student Login & Profile",
    "Course Materials & Assignments",
    "Exam Results & Hall Tickets",
    "Fee Payment",
    "Push Notifications"
  ];

  return (
    <section className="app-section-wrapper" id="download-app">
      <div className="app-main-container">
        
        {/* Left Grid Panel: Descriptions, Checklist & Store Button */}
        <div className="app-content-column">
          <span className="app-tag-label">MOBILE LEARNING</span>
          <h2 className="app-heading-text">Learn Anytime, Anywhere with Our App</h2>
          
          <p className="app-description-text">
            Access course materials, submit assignments, check results, download 
            hall tickets, and stay updated with notifications — all from your smartphone.
          </p>

          {/* Core App Features Bullet Grid */}
          <ul className="app-features-checklist">
            {featureList.map((feature, idx) => (
              <li key={idx} className="checklist-item">
                <span className="check-icon-circle">✓</span>
                <span className="item-text">{feature}</span>
              </li>
            ))}
          </ul>

          {/* Premium Google Play Store App Download Button */}
          <a href="#playstore" className="play-store-download-btn">
            <div className="play-store-icon">
              {/* Clean inline SVG representing the stylized Google Play triangle vector */}
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M5,2.565C4.927,2.646,4.887,2.776,4.887,2.952v18.097c0,0.176,0.04,0.306,0.113,0.386l0.063,0.054L15.15,11.398v-0.296 L5.063,2.511L5,2.565z"/>
                <path d="M18.528,14.808l-3.378-3.41v-0.296l3.379-3.411l0.076,0.044l4.004,2.278c1.143,0.648,1.143,1.713,0,2.363 l-4.004,2.279C18.604,14.764,18.558,14.795,18.528,14.808z"/>
                <path d="M15.226,11.248L5.126,1.065C5.353,0.811,5.748,0.781,6.216,1.047l12.388,7.049L15.226,11.248z"/>
                <path d="M15.226,11.547l3.378,3.151L6.216,21.747c-0.468,0.266-0.863,0.237-1.09-0.017L15.226,11.547z"/>
              </svg>
            </div>
            <div className="play-store-label-box">
              <span className="sub-label">Available on</span>
              <span className="main-label">Google Play Store</span>
            </div>
          </a>
        </div>

        {/* Right Grid Panel: High-Fidelity UI Mockup Smartphone Display frame */}
        <div className="app-graphic-column">
          <div className="phone-outer-shell">
            <div className="phone-inner-screen">
              {/* Dynamic UI Content rendered inside vector container */}
              <div className="phone-screen-branding">
                <div className="screen-logo-icon">🎓</div>
                <h3 className="screen-app-title">CDOE App</h3>
                <p className="screen-university-title">EDULEARNER</p>
              </div>
              
              <div className="screen-links-list">
                <div className="screen-link-pill">Courses</div>
                <div className="screen-link-pill">Results</div>
                <div className="screen-link-pill">Hall Ticket</div>
                <div className="screen-link-pill">Fee Payment</div>
              </div>

              <div className="phone-home-indicator"></div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}